<template>
  <JobComponent/>
</template>

<script>
import JobComponent from '@/components/CreateJobsComponent'
export default {
  name: 'CreateJobs',
  components: {JobComponent
  }
}
</script>
